import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { UpdateFieldCommand } from './update-field.command';

/**
 * Update Field Use Case
 * Updates a field in a form version
 */
@Injectable({ providedIn: 'root' })
export class UpdateFieldUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(command: UpdateFieldCommand): Observable<{ id: string }> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.updateField(command.versionId, command.fieldId, command.field).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to update field ${command.fieldId}`;
        this._state.setErrorCaseForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
